export const BOOKING_TRACKING_REMOVE_REQUEST = 'booking-tracking/remove-request'
export const BOOKING_TRACKING_REMOVE_SUCCESS = 'booking-tracking/remove-success'
export const BOOKING_TRACKING_REMOVE_FAILED = 'booking-tracking/remove-failed'
